import {
  CALCULATE_BASKET_PRICE_REQUEST,
  CALCULATE_BASKET_PRICE_SUCCESS,
  CALCULATE_BASKET_PRICE_FAILURE
} from '../../actionTypes/calculateBasketPriceActionTypes'

const initialState = {
  data: {
    wasPrice: 0,
    saving: 0,
    nowPrice: 0
  },
  meta: {
    errorDetail: ''
  }
}

const buildRequestState = (oldState, payload) => {
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const newState = {
    data: {
      ...oldData,
      ...payload
    },
    meta: {
      ...oldMeta,
      requestDone: false
    }
  }
  return newState
}

const buildSuccessState = (oldState, payload) => {
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const newState = {
    data: {
      ...oldData,
      ...payload
    },
    meta: {
      ...oldMeta,
      requestDone: true
    }
  }
  return newState
}

const buildFailureState = (oldState, payload) => {
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const {
    data: payloadData,
    meta: { errorDetail }
  } = payload
  const newState = {
    data: {
      ...oldData,
      ...payloadData
    },
    meta: {
      ...oldMeta,
      requestDone: true,
      errorDetail
    }
  }
  return newState
}

const calculateBasketPriceReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CALCULATE_BASKET_PRICE_REQUEST:
      return buildRequestState(state, payload)
    case CALCULATE_BASKET_PRICE_SUCCESS:
      return buildSuccessState(state, payload)
    case CALCULATE_BASKET_PRICE_FAILURE:
      return buildFailureState(state, payload)
    default:
      return state
  }
}

export { initialState, calculateBasketPriceReducer }
